import React, { useState } from 'react';
import { Grid, useMediaQuery } from '@mui/material';
import { PrimaryButton, Text, SizeableRoundedDialog, UnderlinedTextInput } from 'library';
import theme from 'theme';
import useLoading from 'library/hooks/useLoading';
import { client } from 'shared';
import { stringify } from 'querystring';

export default function RevealModal({
    open,
    close,
    providerID,
    providerName,
    refresh,
}: {
    open: boolean;
    close: () => void;
    providerID?: number;
    providerName?: string;
    refresh: () => void;
}) {
    const small = useMediaQuery(theme.breakpoints.down('sm'));
    const { loading, setLoading } = useLoading();
    const [code, setCode] = useState<string>('');
    const [ssn, setSsn] = useState<string>();
    const [error, setError] = useState<string>();
    function submit() {
        setLoading(true);
        client(`api/business/reveal/`, { method: 'POST', body: { provider: providerID, code: code } })
            .then((response) => {
                setSsn(response['ssn']);
            })
            .catch((error) => {
                setError(error['error']);
            })
            .finally(() => {
                setLoading(false);
            });
    }
    return (
        <SizeableRoundedDialog
            open={open}
            onClose={() => {
                setSsn('');
                setCode('');
                setError('');
                close();
            }}
            fullScreen={small}
            closeButton
            maxWidth="md"
            style={{ maxWidth: 500 }}
        >
            <Grid container item direction="column" style={{ padding: 20, gap: 10 }}>
                <Text variant="h1">Reveal {providerName}'s SSN?</Text>
                <Text>
                    You will receive a text message with a code to access the provider's SSN. If your number cannot
                    receive texts you will get an email. Please enter the code here. Kindly note that this information
                    is for roster purposes only.
                </Text>
                {!ssn && (
                    <UnderlinedTextInput
                        label="Code"
                        value={code}
                        onChange={(value: string) => {
                            setCode(value);
                        }}
                        error={false}
                        errorText={''}
                    />
                )}
                {ssn ? (
                    <Text>{ssn}</Text>
                ) : (
                    <PrimaryButton
                        disabled={loading}
                        onClick={submit}
                        buttonStyle={{ width: undefined, alignSelf: 'flex-end' }}
                    >
                        Reveal
                    </PrimaryButton>
                )}
                {error && <Text>{error}</Text>}
            </Grid>
        </SizeableRoundedDialog>
    );
}
